<template>

    <div>
      <input v-if="mymask" type="text" class="form-control" ref="input" v-mask="mymask" :value="myValue" @change="updateValue" @input="inputValue" @blur="blur" :disabled="disabled" >
      <input v-else type="text" class="form-control" ref="input" :value="myValue" @change="updateValue" @input="inputValue" @blur="blur" :disabled="disabled" >
    </div>

</template>

<script>
export default {
    props:['value','options','mask', 'disabled'],
    data(){     
        return {myValue:'' }
    },
    created:function(){
        this.myValue = this.value.toString();
    },
    
    watch:{
        value:function(val){
            this.myValue = val
        }
    },

    computed:{
        mymask:function(){
            if(this.mask){
               return this.mask 
            }else{
               return false
            }
        }
    },
    
    methods:{
         updateValue:function(){
            let val = this.$refs.input.value;
            this.myValue = val
            this.$emit('change',val)
            this.$emit('input',val)
        },
        blur:function(val){
            this.updateValue()
            this.$emit('blur',val)
        },
         inputValue:function(e){
            let val = this.$refs.input.value;
            this.myValue = val
            // console.log('field-string:' + val)
            this.$emit('input',val)
        },

    }
}
</script>

<style>

</style>
